import React from "react";
import styles from "./manual-y-range-fields.module.scss";
import { CheckBoxWithText } from "@src/components/atoms/check-box-with-text/check-box-with-text";
import { Input2025 } from "@src/components/atoms/input-2025/input-2025";
import { Button } from "@src/components/atoms/buttons/button/button";

const cssClassName = "manual-y-range-fields";

/** Wording for the toggle and the two bounds. Each editor passes its own
 *  module's strings, so this component carries no translations of its own. */
export interface ManualYRangeFieldsTexts {
  manualYRangeLabel: string;
  yMinLabel: string;
  yMaxLabel: string;
  resetYRangeLabel: string;
}

interface ManualYRangeFieldsProps {
  texts: ManualYRangeFieldsTexts;
  enabled: boolean;
  min: string;
  max: string;
  onEnabledChange: (enabled: boolean) => void;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  onReset: () => void;
}

/**
 * The line charts' manual Y range: a checkbox that reveals a min / max pair
 * and a reset. Off means the axis stays automatic — ticking is the explicit
 * control, and unticking or resetting puts the axis back to automatic on save.
 * Dumb on purpose: the editor keeps the state and decides what a reset clears.
 */
export const ManualYRangeFields = ({
  texts,
  enabled,
  min,
  max,
  onEnabledChange,
  onMinChange,
  onMaxChange,
  onReset,
}: ManualYRangeFieldsProps) => (
  <>
    <div className={styles[`${cssClassName}__field`]}>
      <CheckBoxWithText
        text={texts.manualYRangeLabel}
        checkboxState={enabled}
        handleCheckBoxClick={() => onEnabledChange(!enabled)}
      />
    </div>

    {enabled && (
      <div className={styles[`${cssClassName}__manual-range-wrapper`]}>
        <Input2025
          labelText={texts.yMinLabel}
          inputPlaceHolder={texts.yMinLabel}
          inputValue={min}
          onChangeFunc={(event) => onMinChange(event.target.value)}
          inputVariant="dark-background"
        />
        <Input2025
          labelText={texts.yMaxLabel}
          inputPlaceHolder={texts.yMaxLabel}
          inputValue={max}
          onChangeFunc={(event) => onMaxChange(event.target.value)}
          inputVariant="dark-background"
        />
        <Button
          fun={onReset}
          text={texts.resetYRangeLabel}
          variant={["warning"]}
        />
      </div>
    )}
  </>
);
